var fn_share_tools = function() {

    if ($('#at4-share.atss-right')) {
        var bottomPos = $('#at4-share.atss-right .at-share-btn:last-of-type')[0].getBoundingClientRect().bottom + $(window)['scrollTop']();
        $('.content-share-tools__wrapper').css('top', bottomPos + 1);
    }
}